<template>
  <div>
    <div class="row">
      <div class="col-md-8 d-flex">
        <b-form-group id="input-group-1" class="col-8" label="Pesquisar" label-for="filter">
          <b-input-group>
            <b-form-input
              id="filter"
              v-model="filter"
              type="text"
              placeholder="Pesquisar..."
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="onFilter"
                >Pesquisar</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Tipo de Pesquisa" v-if="tipoPesquia">
          <b-form-radio-group v-model="tipoPesquisa">
            <b-form-radio value="cliente">Titular</b-form-radio>
            <b-form-radio value="dependente">Dependente</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <b-form-group label="Status Conveniado" v-if="isStatusConveniado">
          <b-form-radio-group v-model="statusConveniado">
            <b-form-radio value="ativo">Ativo</b-form-radio>
            <b-form-radio value="inativo">Inativo</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>
      
      <div class="col d-flex align-items-center justify-content-end">
        <button class="btn btn-primary" @click="$refs.btnexport.$el.click()">
          Exportar Excel
          <vue-excel-xlsx
            ref="btnexport"
            style="display: none"
            :data="tableItems"
            :columns="tablesFields"
            :filename="'log-robo'"
            :sheetname="'robo'"
          >
          </vue-excel-xlsx>
        </button>
      </div>
    </div>
    <b-table
      striped
      hover
      :items="tableItems"
      :fields="tablesFields"
      :per-page="perPage"
    >
      <template v-slot:cell(actions)="row">
        <div class="btn-group mb-2" v-if="!(usuario.tipo=='verificador')">
          <button
            v-b-tooltip.hover
            title="Deletar"
            type="button"
            class="btn btn-light"
            @click="modalDelete(row.item._id)"
          >
            <i class="uil uil-trash-alt"></i>
          </button>
          <button
            v-b-tooltip.hover
            title="Editar"
            type="button"
            class="btn btn-light"
            @click="modalEdit(row.item)"
          >
            <i class="uil uil-edit-alt"></i>
          </button>
        </div>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      size="md"
      :total-rows="rows"
      :per-page="perPage"
    ></b-pagination>
    <b-modal v-model="modal" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="modal = false">Não</b-button>
        <b-button variant="danger" @click="handleDelete">Sim</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['tableItems', 'tablesFields','search', 'rows', 'perPage', 'filterFields', 'tipoPesquia', 'isStatusConveniado'],
  data() {
    return {
      modal: false,
      itemId: '',
      filter: '',
      currentPage: '',
      tipoPesquisa: '',
      statusConveniado: 'ativo',
      usuario: this.$store.state.auth.currentUser.usuario,
    }
  },
  watch: {
    currentPage(){
      this.$emit('changePage', this.currentPage)
    }
  },
  methods: {
    onFilter(){
      if(this.tipoPesquia||this.isStatusConveniado)
        this.$emit('onFilter', {filter: this.filter, tipoPesquisa: this.tipoPesquisa, statusConveniado:this.statusConveniado})
      else
        this.$emit('onFilter', this.filter)
    },
    modalDelete(item) {
      this.modal = true
      this.itemId = item
    },

    handleDelete() {
      this.$emit('onDelete', this.itemId)
      this.itemId = null
      this.modal = false
    },
    formatDate(date){
      if(date)
        return moment(date).format("DD/MM/YYYY")
    },
    modalEdit(item) {
      this.$emit('onEdit', item)
    },
    listando(){
      this.$emit('listando')
    }
  },
}
</script>

<style></style>
